export default __webpack_public_path__ + "static/media/blog-img125.916b7292.jpg";